import { FC } from "react";
import { HeartIcon, LinkIcon } from "@heroicons/react/24/solid";

const Footer: FC = () => {
	return (
		<footer className="mt-20 bg-gradient-to-r from-[#060b13] via-[#0a1425] to-[#0b1a2e] text-slate-100 border-t border-slate-700/60">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					<div className="space-y-4">
						<div className="flex items-center space-x-3">
							<div className="w-8 h-8 pitch-gradient rounded-lg flex items-center justify-center">
								<span className="text-white font-bold text-sm">IE</span>
							</div>
							<h3 className="text-2xl leading-none">Inside Edge</h3>
						</div>
						<p className="text-slate-300 leading-relaxed">
							Broadcast-grade cricket analytics built for clubs, captains, and fans who want sharper
							reads on performance trends.
						</p>
					</div>

					<div className="space-y-4">
						<h4 className="text-lg font-semibold text-white">Data Pipeline</h4>
						<div className="space-y-3">
							<div className="flex items-center space-x-2 text-slate-300">
								<LinkIcon className="h-4 w-4 text-emerald-300" />
								<span>All statistics sourced from</span>
							</div>
							<a
								href="https://play.cricket.com.au/"
								target="_blank"
								rel="noopener noreferrer"
								className="inline-flex items-center space-x-2 text-emerald-300 hover:text-emerald-200 transition-colors duration-200 font-medium"
							>
								<span>play.cricket.com.au</span>
								<LinkIcon className="h-4 w-4" />
							</a>
						</div>
					</div>

					<div className="space-y-4">
						<h4 className="text-lg font-semibold text-white">Contact</h4>
						<div className="space-y-3">
							<p className="text-slate-300">Questions, requests, or ideas?</p>
							<p className="text-slate-300">Need to add your club?</p>
							<a
								href="mailto:dvishist27@gmail.com"
								className="inline-flex items-center space-x-2 text-orange-300 hover:text-orange-200 transition-colors duration-200 font-medium"
							>
								<span>dvishist27@gmail.com</span>
							</a>
						</div>
					</div>
				</div>

				<div className="mt-12 pt-8 border-t border-slate-700/70">
					<div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
						<p className="text-slate-400 text-sm">Built for competitive cricket analysis.</p>
						<div className="flex items-center space-x-2 text-slate-400 text-sm">
							<span>Made with</span>
							<HeartIcon className="h-4 w-4 text-orange-400" />
							<span>for the cricket community</span>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
